import React from "react";
import MUIRadioGroup, {
  RadioGroupProps as MUIRadioGroupProps
} from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";

/**
 * Props to use when instantiating a `radio group` component.
 */
export interface RadioGroupProps extends MUIRadioGroupProps {
  /**
   * An optional label prop. The ID should be provided if a label is.
   */
  label?: string;

  /**
   * An optional id prop. The ID should be provided if a label is.
   */
  id?: string;
}

/**
 * A `radio group` component.
 */
export function RadioGroup({
  label,
  id = "",
  children,
  ...props
}: RadioGroupProps) {
  const group = (
    <MUIRadioGroup aria-labelledby={id} {...props}>
      {children}
    </MUIRadioGroup>
  );

  if (label) {
    return (
      <>
        <FormLabel id={id}>{label}</FormLabel>
        {group}
      </>
    );
  }

  return group;
}
